module.exports = "https://cwa.roocdn.com/_next/static/street.f73b4f8f.svg";